import Config from '@/config'

const commonDefaultState = {
  isAuthenticated: false,
  canViewerShare: false,
  canEditPresentation: false,
  currentTokenValue: null,
  ahaSequenceNumber: 0,
  offsetTime: 0,
  isShowingSlideSearchPopup: false,
  isDocToQuizGeneratingBoxVisible: false,
  integrationPlatform: Config.integrationPlatform,
  googleSlideActiveId: null,
  isCreatingGoogleSlide: false,
}

export default commonDefaultState
